import React from "react";

export default function OrderIcon()
{
      return (
            <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M29.5589 7.18589V7.14571C29.5558 5.55703 28.2677 4.26899 26.6794 4.26592H16.793C16.6543 4.26682 16.517 4.23692 16.3912 4.17836C16.2654 4.1198 16.1542 4.03404 16.0655 3.92728L13.5844 1.01593C13.3149 0.696286 12.9785 0.439654 12.599 0.264126C12.2195 0.0885968 11.8061 -0.00155646 11.388 2.03321e-05H3.3251C1.73642 0.00339137 0.448377 1.29144 0.445312 2.87981V7.18589H29.5589ZM29.5589 9.62592H0.445312V21.1202C0.448377 22.7089 1.73642 23.9969 3.3251 24H26.6791C28.2677 23.9966 29.5558 22.7089 29.5589 21.1202V9.62592Z" fill="var(--color-icon-card)" />
            </svg>

      );
}
